import {BaseMixins} from '../component/base-mixins'
import {Component} from '../component/decorator';
@Component
export class PageResultListMixins extends BaseMixins {

    /**
     * 路由跳转
     * @param name route name
     * @param query query 参数
     */
    push(name:string, query:any){
        this.$router.push({name:name, query:query});
    }

    /**
     * 编辑按钮 permission默认页面权限 + .Edit
     * @param check 业务逻辑验证
     * @param otherQueryField query额外属性
     */
    colEditBtnP(check?:Function, otherQueryField?:string[]){
        return this.colCommonBtnP("Action.Edit", this.$route.meta.access[0] + ".Edit", this.getRouterNamePrefix() + ".edit", check, otherQueryField);
    }

    /**
     * 详情按钮 permission默认页面权限 + .Detail
     * @param check 业务逻辑验证
     * @param otherQueryField query额外属性
     */
    colDetailBtnP(check?:Function, otherQueryField?:string[]){
        return this.colCommonBtnP("Action.Detail", this.$route.meta.access[0] + ".Detail", this.getRouterNamePrefix() + ".detail", check, otherQueryField);
    }

    /**
     * 公共按钮
     * @param label 多语言key
     * @param permission 权限
     * @param routeName 路由名称
     * @param check 业务逻辑验证
     * @param otherQueryField query额外属性
     */
    colCommonBtnP(label:string, permission:string, routeName:string,check?:Function, otherQueryField?:string[]){
        return {
            label: label,
            permission: permission,
            check:check,
            callback:row => {
                let query = {id:row.id};
                if(otherQueryField){
                    otherQueryField.forEach(item => {
                        query[item] = row[item];
                    })
                }
                this.push(routeName, query);
            }
        }
    }

    /**
     * 获取dispatch type前缀
     */
    getRouterNamePrefix(){
        let length = this.$route.matched.length;
        return this.$route.matched[length-2].name;
    }
}